import React, {Component} from 'react';
import {Link} from "react-router-dom";
import {Modal, ModalFooter, ModalHeader} from "reactstrap";
import { withTranslation } from 'react-i18next';
import {Bell, ClockCounterClockwise, GearSix} from "@phosphor-icons/react";


class BusinessUnitTabsComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            changesMade: this.props.changesMade,
            tabUrlClicked: null
        };

        this.toggle = this.toggle.bind(this);
        this.handleCancelTabChange = this.handleCancelTabChange.bind(this);
        this.handleContinueNotSaving = this.handleContinueNotSaving.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (this.props.changesMade !== prevProps.changesMade) {
            this.setState({
                changesMade: this.props.changesMade
            });
        }
    }

    handleTabClick = (e) => {
        if (this.state.changesMade) {
            e.preventDefault();
            this.setState({
                modal: true,
                tabUrlClicked: e.currentTarget.getAttribute('href')
            });
        }
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    getModalClassName() {
        if(this.props.className)
            return this.props.className
        else
            return "modal-body"
    }

    handleCancelTabChange() {
        this.toggle()
    }

    handleContinueNotSaving() {
        this.props.goToTabUrl(this.state.tabUrlClicked);
    }

    render() {
        const { t } = this.props;
        const tabs = [
            {
                key: 'global-info',
                label: t('business_unit_tabs.global_info'),
                to: `/business-unit/${this.props.businessUnitId}/`,
                active: this.props.activeTab === '-first',
                icon: GearSix,
                id: undefined,
            },
            {
                key: 'budget-history',
                label: t('business_unit_tabs.budget_history'),
                to: `/business-unit/${this.props.businessUnitId}/budget-history`,
                active: this.props.activeTab === '-third',
                icon: ClockCounterClockwise,
                id: undefined,
            },
            {
                key: 'alerts',
                label: t('business_unit_tabs.alerts_configuration'),
                to: `/business-unit/${this.props.businessUnitId}/alerts-configuration`,
                active: this.props.activeTab === '-last',
                icon: Bell,
                id: 'alerts_configuration_link',
            },
        ];

        return (
            <div className="filters client-tabs-v2 business-unit-tabs-v2">
                <ul className="tabs">
                    {tabs.map(tab => (
                        <li key={tab.key}>
                            <Link
                                onClick={this.handleTabClick}
                                id={tab.id}
                                className={`tab-button${tab.active ? ' -active' : ''}`}
                                to={tab.to}
                            >
                                <span className="client-tab-icon">
                                    <tab.icon size={16} weight={tab.active ? 'fill' : 'regular'}/>
                                </span>
                                <span>{tab.label}</span>
                            </Link>
                        </li>
                    ))}
                </ul>
                <Modal key="modal" isOpen={this.state.modal} toggle={this.toggle} className={this.getModalClassName()}>
                    <ModalHeader toggle={this.toggle}></ModalHeader>
                    <div className="modal-section">
                        <p>{t('business_unit_tabs.unsaved_changes_message')}</p>
                    </div>
                    <ModalFooter>
                        <div style={{
                            display: "flex",
                            justifyContent: "center",
                            width: "100%",
                            textAlign: "center",
                            clear:"both"
                        }}>
                            <div style={{margin:"0 10px"}}><input onClick={this.handleCancelTabChange} type="button" value={t('business_unit_tabs.go_back')} className="btn"/></div>
                            <div style={{margin:"0 10px"}}><input onClick={this.handleContinueNotSaving} type="button" value={t('business_unit_tabs.change_without_saving')} className="btn -alt"/></div>
                        </div>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}

export const BusinessUnitTabs = withTranslation()(BusinessUnitTabsComponent);
